import styled from 'styled-components'

const WebsiteTab = styled.div`
  width: 100%;
`

const SubHeader = styled.div`
  font-size: 14px;
  color: var(--color-text-secondary);
  font-weight: 600;
  margin-bottom: 8px;
`

const SelectionDiv = styled.div`
  width: 280px;
  max-width: 100%;
  margin-bottom: 8px;
`

const PaginationWrap = styled.div`
  margin-top: 0.5rem;
`

export {WebsiteTab, SelectionDiv, SubHeader, PaginationWrap}
